export class AdmissionReasonInformation {
    Title: string;
    ForeignTitle: string;
    constructor() {
    }
}